export class ErrorBoundaryError extends Error {
  constructor(message, options) {
    super(message, options);
    this.options = options;
  }
}